import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { canAccessRoute } from '@/models/route/routeAccess.util.ts';
import { settlementsToDo } from '@/views/settlements/util/settlementsToDo.util.ts';
import { useGetSettlements } from '@/views/settlements/util/useGetSettlements.util.ts';

type Return = {
  toDoCount: number;
};

export const useSettlementsToDo = (): Return => {
  const { permissions, role } = useUserContext();
  const hasAccess = canAccessRoute(RouteEnum.SETTLEMENTS, { permissions, role });
  const { settlements } = useGetSettlements({ enabled: hasAccess });

  return {
    toDoCount: settlements ? settlementsToDo(settlements.payments).payments.length : 0,
  };
};
